"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * This function gives you a string from a list that is closest to the one you entered
 * @param {string} value the input string
 * @param {FuzzySet} possibleValues the set of possible values
 * @param {object} config the configuration overrides
 * @returns {string} the suggestion
 */
var getDidYouMeanSuggestion = function getDidYouMeanSuggestion(value, possibleValues) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _config$preprocess = config.preprocess,
    preprocess = _config$preprocess === void 0 ? function (string) {
      return string;
    } : _config$preprocess,
    _config$postprocess = config.postprocess,
    postprocess = _config$postprocess === void 0 ? function (string) {
      return string;
    } : _config$postprocess,
    _config$commonMistake = config.commonMistakes,
    commonMistakes = _config$commonMistake === void 0 ? {} : _config$commonMistake,
    _config$threshold = config.threshold,
    threshold = _config$threshold === void 0 ? 0.5 : _config$threshold;
  var preProcessedValue = preprocess(value);
  if (preProcessedValue) {
    var suggestions = possibleValues.get(preProcessedValue);
    if (suggestions && suggestions[0]) {
      var _suggestions$ = _slicedToArray(suggestions[0], 2),
        score = _suggestions$[0],
        string = _suggestions$[1];
      if (score >= threshold) {
        if (commonMistakes[string]) {
          return postprocess(commonMistakes[string], value);
        }
        if (score < 1) {
          return postprocess(string, value);
        }
      }
    }
  }
  return null;
};
var _default = exports["default"] = getDidYouMeanSuggestion;